<template>
    <div id="ZamenVaMoaref">
        <card back>
            <template v-slot:header>
                <h4>ضامنین و معرف ها</h4>
                <hr />
            </template>
            <template v-slot:content>
                <DetailUser>
                    <template v-slot:Pnl-r1>
                        <h1 class="border-left"><i class="fad fa-user font-size-icon" style="font-size: 30px"
                                title="مشخصات کاربر"></i></h1>
                    </template>
                    <template v-slot:Pnl-r2>
                        <span>شماره مشتری : </span>
                        <span class="font-weight-bold text-logo" dir="rtl"> {{ AzaInfo.ShomareOzv }}</span>
                    </template>
                    <template v-slot:Pnl-r3>
                        <span>مشخصات : </span>
                        <span class="font-weight-bold text-logo" dir="rtl">{{ AzaInfo.OzvName }}
                            {{ AzaInfo.OzvFamily }}</span>
                    </template>
                    <template v-slot:Pnl-r4>
                        <span>کد ملی : </span>
                        <span class="font-weight-bold text-logo"
                            dir="rtl">{{ AzaInfo.CodeMeli == null || AzaInfo.CodeMeli == '' ? '[ ثبت نشده ]' : AzaInfo.CodeMeli }}</span>
                    </template>
                </DetailUser>
                <div class="mb-3 mt-3">
                    <a v-if="AddZamenVaMoaref == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;"
                        @click="AddZamenVaMoaref = 1" title="افزودن">
                        <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
                    </a>
                    <a v-if="AddZamenVaMoaref != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;"
                        @click="AddZamenVaMoaref = 0;Refresh()" title="لغو افزودن">
                        <h4><i class="fas fa-times text-danger"></i></h4>
                    </a>
                </div>
                <!-- Add And Edit     -->
                <div class="row" v-if="AddZamenVaMoaref!=0">
                    <div class="col-12 mt-3">
                        <tab :tab="Tablist">
                            <template v-slot:content0>
                                <div class="row pb-3 border-bottom mr-2 ml-2">
                                    <div class="col-md-3 col-12 text-right">
                                        <small id="LblTblComboIdNoe10">نوع </small>
                                        <SearchableCombo :edit="false" @ResultCombo="ValueResultComboIdNoe10"
                                            :rownumintable="1" :queryString="{ id: 10}" :action="'TblCombo/GettblCombo'"
                                            :method="'GET'" :idinput="'ComboIdNoe10'" :keyItem="'ComboIdNoe10'"
                                            :disabled="false" :defaultvalue="DataAxios.TblComboIdNoe10">
                                        </SearchableCombo>
                                    </div>
                                    <div class="col-lg-3 col-12 text-right">
                                        <small id="LblIsOzv">نوع مشتری</small>
                                        <span class="form-control p-1">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input InputText" id="IsOzv"
                                                    @change="ClearForm($event)" v-model="DataAxios.IsOzv" />
                                                <label class="custom-control-label" for="IsOzv">مشتری صندوق</label>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div class="row mt-5 mr-2 ml-2" v-if="DataAxios.IsOzv">
                                    <div class="col-md-2 col-10 mt-1 text-right">
                                        <small id="LblShomareOzv">شماره مشتری </small>
                                        <input type="text" id="ShomareOzv" v-mask="$Get_FormatShomareOzv()"
                                            @keydown="SearchShomareozv($event)" @focusout="SearchShomareozv($event)"
                                            :placeholder="$session.get('UserInfo').codeShobe.trim() + '-' "
                                            class="form-control required" dir="ltr" v-model="DataAxios.ShomareOzv" />
                                    </div>

                                    <div class="col-md-2 col-10 mt-1 text-right">
                                        <small id="LblOzvName">نام </small>
                                        <input type="text" class="form-control text-center" id="txtOzvName" dir="ltr"
                                            disabled v-model="DataAxios.OzvName" />
                                    </div>
                                    <div class="col-md-2 col-10 mt-1 text-right">
                                        <small id="LblOzvFamily">نام خانوادگی </small>
                                        <input type="text" class="form-control text-center" dir="ltr" disabled
                                            v-model="DataAxios.OzvFamily" />
                                    </div>

                                    <div class="col-md-3 col-12 mt-1 text-right">
                                        <small id="LblTblTaahodatIdHesabZamenVaMoaref">شماره حساب</small>
                                        <select class="form-control required" @focus="GetAzaTaahodat()"
                                            v-model="DataAxios.TblTaahodatIdHesabZamenVaMoaref">
                                            <option v-if="AddZamenVaMoaref!=0" :value="null">
                                                -- شماره حساب را انتخاب کنید --
                                            </option>
                                            <option v-if="ListHesabOzv.length == 0" value="-1" disabled>
                                                هیچ عضوی انتخاب نشده
                                            </option>
                                            <option v-for="Hesab in ListHesabOzv" :key="Hesab.Id" :value="Hesab.Id">
                                                <span>{{ Hesab.VCode }}</span>
                                            </option>
                                        </select>
                                    </div>
                                    <!-- فرم اعضا حساب  -->
                                    <!-- <div class="col-md-1 pr-0 col-2 mt-1 text-right">
                                        <button type="button" class="btn btn-outline-success mt-3" @click="IsVarizBeHesab = false; AzaPasAndJari(); " dir="ltr">
                                            <span class="fa fa-list" tabindex="-1"></span>
                                        </button>
                                    </div> -->
                                    <div class="col-md-2 col-10 mt-1 text-right">
                                        <small id="LblTblAzaIdHesabZamen">شماره حساب بانکی </small>
                                        <SearchableCombo :edit="false" @ResultCombo="ValueResultTblAzaHesab"
                                            :rownumintable="1" :queryString="{ id: DetailZamen.Id}"
                                            :action="'TblCombo/GetListAzaHesab'" :method="'GET'"
                                            :idinput="'TblAzaHesab'" :keyItem="'TblAzaHesab'" :disabled="false"
                                            :defaultvalue="DataAxios.TblAzaIdHesabZamen">
                                        </SearchableCombo>
                                    </div>
                                    <!-- فرم حساب های باکی  -->
                                    <!-- <div class="col-md-1 pr-0 col-2 mt-3 text-right">
                                        <router-link tabindex="-1" class="btn btn-outline-orange mt-3" :to="{name: 'AzaHesabHa',params: {TblAzaId: DetailZamen.Id,},}">
                                            <i class="fa fa-list"></i>
                                        </router-link>
                                    </div> -->
                                    <div class="col-md-2 col-10 mt-3 text-right">
                                        <small id="LblMobile">موبایل </small>
                                        <input v-mask="'09#########'" :placeholder="'09'" type="text"
                                            class="form-control" dir="ltr" v-model="DataAxios.Mobile" disabled />
                                    </div>
                                    <div class="col-lg-2 col-12 mt-3 text-right">
                                        <small id="LblIsKasr">کسر از ضامن</small>
                                        <span class="form-control p-1 text-center mt-1">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input InputText"
                                                    id="smsexpect1" v-model="DataAxios.IsKasr" />
                                                <label class="custom-control-label" for="smsexpect1">کسر از ضامن</label>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="col-lg-1 col-12 mt-3 text-right"></div>
                                    <div class="col-lg-2 col-12 mt-3 text-right" v-if="DataAxios.IsKasr">
                                        <small id="LblMablaghKasrBeMeghdarGhest">کسر مبلغ قسط</small>
                                        <span class="form-control p-1 text-center mt-1">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input InputText" id="a1"
                                                    v-model="DataAxios.MablaghKasrBeMeghdarGhest" />
                                                <label class="custom-control-label" for="a1">کسر مبلغ قسط</label>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="col-md-2 col-10 mt-3 text-right" v-if="DataAxios.IsKasr">
                                        <small id="LblMablaghKasr">مبلغ کسر </small>
                                        <input @keypress="$ValidNumber($event, 13, true); $DotInMablagh($event, 13); "
                                            @keyup="$PutCommatoInput()" @focus="Focus($event)"
                                            @focusout="FocusOut($event)" type="text"
                                            class="form-control InputText text-center 3ragham" dir="ltr"
                                            v-model="DataAxios.MablaghKasr" />
                                    </div>
                                </div>
                                <div class="row mt-5 mr-2 ml-2" v-else>
                                    <div class="col-md-2 col-10 mt-1 text-right">
                                        <small id="LblCodeMelli">کد ملی </small>
                                        <input type="text" class="form-control d-none" dir="ltr" />
                                        <input type="text" class="form-control required required-CodeMeli" dir="ltr"
                                            maxlength="10" v-model="DataAxios.CodeMelli"
                                            @keypress="$ValidNumber($event, 10)"
                                            @input="$CheckupLengthCodeMeli($event)" />
                                    </div>
                                    <div class="col-md-4 col-10 mt-1 text-right">
                                        <small id="LblNameFamily">مشخصات </small>
                                        <input type="text" class="form-control required" dir="ltr"
                                            @keypress="$ValidPersian($event, 30)" v-model="DataAxios.NameFamily" />
                                    </div>
                                    <div class="col-md-2 col-10 mt-1 text-right">
                                        <small id="LblTel">تلفن </small>
                                        <input type="text" v-mask="'###-########'" class="form-control" dir="ltr"
                                            v-model="DataAxios.Tel" @keypress="$ValidNumber($event, 15)" />
                                    </div>
                                    <div class="col-md-2 col-10 mt-1 text-right">
                                        <small id="LblMobile">موبایل </small>
                                        <input v-mask="'09#########'" :placeholder="'09'" type="text"
                                            class="form-control required" dir="ltr" v-model="DataAxios.Mobile" />
                                    </div>
                                    <div class="col-md-2 col-10 mt-1 text-right">
                                        <small id="LblPedar">نام پدر </small>
                                        <input type="text" class="form-control required"
                                            @keypress="$ValidPersian($event, 20)" dir="ltr" v-model="DataAxios.Pedar" />
                                    </div>
                                    <div class="col-md-6 col-10 mt-1 text-right">
                                        <small id="LblAdress">نشانی </small>
                                        <textarea class="form-control required" rows="1"
                                            @keypress="$ValidPersian($event, 50)" v-model="DataAxios.Adress"></textarea>
                                    </div>
                                </div>
                                <div class="row mt-3 mr-2 ml-2">
                                    <div class="col-lg-3 col-12 mt-1 text-right">
                                        <small id="LblExpireDateForSendSms">تاریخ ارسال پیامک به ضامن (تا تاریخ)</small>
                                        <date-picker :editable="true" v-model="DataAxios.ExpireDateForSendSms"
                                            color="dimgray">
                                        </date-picker>
                                    </div>
                                    <div class="col-lg-9 col-12 mt-1 text-right">
                                        <small id="LblDesZamenVaMoaref">توضیــحات</small>
                                        <textarea class="form-control" @keypress="$ValidPersian($event, 60)"
                                            v-model="DataAxios.DesZamenVaMoaref" rows="1"></textarea>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:content1>
                                <div class="row" v-if="DataAxios.IsOzv">
                                    <div class="col-lg-3 col-12 text-right">
                                        <small id="LblIsMasdodIfGhestMoavagh">انسداد در صورت تعویق اقساط</small>
                                        <span class="form-control p-1 text-center mt-1">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input InputText" id="a1"
                                                    v-model="DataAxios.IsMasdodIfGhestMoavagh" />
                                                <label class="custom-control-label" for="a1">انسداد در صورت تعویق
                                                    اقساط</label>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="col-lg-2 col-12 text-right">
                                        <small id="LblIsMasdoodShode">انسداد حساب</small>
                                        <span class="form-control p-1 text-center mt-1">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input InputText" id="a1"
                                                    v-model="DataAxios.IsMasdoodShode" />
                                                <label class="custom-control-label" for="a1">انسداد حساب</label>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="col-lg-3 col-12 mt-1 text-right">
                                        <small id="LblMabEnsedad">مبلغ انسداد</small>
                                        <input type="text" @keypress="
                        $ValidNumber($event, 13, true);
                        $DotInMablagh($event, 13);
                      " @keyup="$PutCommatoInput()" @focus="Focus($event)" @focusout="FocusOut($event)"
                                            class="form-control 3ragham text-center" dir="ltr"
                                            v-model="DataAxios.MabEnsedad" />
                                    </div>
                                    <div class="col-lg-2 col-12 mt-1 text-right">
                                        <small id="LblDarsadEnsedad">درصد انسداد</small>
                                        <input type="text" class="form-control text-center" dir="ltr"
                                            @keypress="$ValidNumber($event, 2)" v-model="DataAxios.DarsadEnsedad" />
                                    </div>
                                    <div class="col-lg-2 col-12 mt-1 text-right">
                                        <small id="LblTartibEnsedad">ترتیب آزاد سازی</small>
                                        <input type="text" class="form-control 3ragham text-center" dir="ltr"
                                            @keypress="$ValidNumber($event, 3)" v-model="DataAxios.TartibEnsedad" />
                                    </div>
                                    <div class="col-lg-3 col-12 mt-1 text-right">
                                        <small>روش آزاد سازی</small>
                                        <combo @ValueResult="
                        ValueResultTblComboRaveshAzadSazi23ZamenVaMoaref
                      " :IdEditMode="
                        DataAxios.TblComboRaveshAzadSazi23ZamenVaMoaref
                      " :IsLoad="true" :IsDefault="true" :ActionUrl="'GettblCombo'" :Params="23"
                                            :Op_TextDefult="'روش آزاد سازی را انتخاب کنید'"></combo>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="col-lg-2 col-12 mt-1 text-right">
                                        <small id="LblCodePosti">کد پستی</small>
                                        <input type="text" class="form-control 3ragham text-center" dir="ltr"
                                            @keypress="$ValidNumber($event, 12)" v-model="DataAxios.CodePosti" />
                                    </div>
                                    <div class="col-lg-2 col-12 mt-1 text-right">
                                        <small id="LblTelMahalKar">تلفن محل کار</small>
                                        <input type="text" v-mask="'###-########'" class="form-control text-center"
                                            @keypress="$ValidNumber($event, 11)" dir="ltr"
                                            v-model="DataAxios.TelMahalKar" />
                                    </div>
                                    <div class="col-lg-6 col-12 mt-1 text-right">
                                        <small id="LblAdresMahalKar">نشانی محل کار</small>
                                        <textarea type="text" class="form-control text-center" rows="1"
                                            @keypress="$ValidPersian($event, 50)" dir="ltr"
                                            v-model="DataAxios.AdresMahalKar"></textarea>
                                    </div>
                                    <div class="col-lg-2 col-12 mt-1 text-right">
                                        <small id="LblShoghl">شغل</small>
                                        <input type="text" @keypress="$ValidPersian($event, 20)"
                                            class="form-control text-center" dir="ltr" v-model="DataAxios.Shoghl" />
                                    </div>
                                </div>
                            </template>
                        </tab>
                        <hr />
                    <button v-if="AddZamenVaMoaref!=0" class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت اطلاعات</button>
                    <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Refresh()">انصراف</button>
                    </div>
                    
                </div>
                <!-- Add And Edit     -->

                <Bnp-Grid :Sortable="true" :action="true" :propsRows="rows" :propsColumn="columns" :hasRowNum="true"
                    v-if="$store.state.renderComponentGrid && AddZamenVaMoaref==0">
                    <template slot="action-slot" slot-scope="props">
                        <button  class="btn btn-lg text-info" @click="OnEdit(props.props)" title="اصلاح"><i class="hover-warning mx-3 fad fa-marker text-secondary Pointer"></i></button>
                        <i class="hover-danger mx-3 fad fa-trash text-secondary Pointer" @click="OnDelete(props.props)"></i>
                    </template>
                </Bnp-Grid>
            </template>
        </card>
    </div>
</template>
<script>
    import Card from '@/components/Card/Card.vue'
    import DetailUser from '@/components/BnpCash/SanadComponents/DetailUser.vue'
    import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
    import Tab from '@/components/Tab/Tab.vue'
    import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

    export default {
        components: {
            datePicker: VuePersianDatetimePicker,
            Card,
            DetailUser,
            BnpGrid,
            Tab,
            SearchableCombo
        },
        data() {
            return {
                 DataAxiosPost: {
                    ArryfildValue: {},
                    Method: 'post',
                    Action: '',
                    Token: this.$session.get('Token'),
                    From: 'Body',
                },
                ListHesabOzv: [],
                DetailZamen: [],
                DataAxios: {IsOzv:true},
                Tablist: [{
                    header: 'اطلاعات'
                }, {
                    header: 'انســداد'
                }],
                AddZamenVaMoaref: 0,
                DataAxoisColumns: {
                    ArryfildValue: {
                        SoftwareId: 2,
                        UserId: 1,
                        FormName: "frmZamenVaMoaref",
                        ShowView: 0,
                    },
                    Method: "post",
                    Action: "ReadGridColumns",
                },
                DataAxiosSearch: {
                    ArryfildValue: {}
                },
                rows: [],
                columns: [],
                DataAxiosDelete: {
                    ArryfildValue: "",
                    Method: "Delete",
                    Action: "ZamenVaMoaref",
                    Token: this.$session.get("Token"),
                },
                Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
            }
        },
        props: ["TblTaahodatId", "AzaInfo"],
        methods: {
            OnDelete(row){
                 this.$store.state.OldDataForLog = JSON.stringify(row)
                this.DataAxiosDelete.ArryfildValue = { id: row.Id }
                 this.$DeleteDatapropmise(this.DataAxiosDelete, this.Sweet).then((result) => {
                    if (result == true) {
                    this.$SetLog(row, 1, 1, 'ZamenVaMoare', 'ضامن و معرف')
                    this.Search();
                    }
                })
            },
            OnEdit(row){
                 this.$store.state.OldDataForLog = JSON.stringify(row)
                this.AddZamenVaMoaref=1
                this.DataAxios=row
            },
            SaveDeta() {
                if (this.$ValidForm(this.$route.name)) {

                    this.DataAxiosPost.Action = this.$route.name
                    this.DataAxiosPost.ArryfildValue = this.DataAxios
                    this.$PostData(this.DataAxiosPost).then((data) => {
                    if (data.status == 'Ok') {
                    
                        this.$toasted.success('ردیف ضمانت با موفقیت ایجاد شد', {
                            action: {
                            text: 'بستن',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0)
                            },
                            },
                        })
                        this.Refresh()
                    } else {
                        if (data.eNum == '2601') {
                        this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                        }
                        if (data.status == 'Not Ok') {
                        if (data.mes != undefined) {
                            this.$mySweetDefaultTost('خطایی رخ داده!', data.mes, 'error', 3000)
                        } else {
                            this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                        }
                        }
                    }
                    }).finally(() => {
                    this.$store.state.renderComponentGrid = false;
                    this.$nextTick(() => {
                        this.Search();
                        this.$store.state.renderComponentGrid = true;
                    });

                })
      }
                },
            ClearForm(e) {
                this.DataAxios.IsOzv = e.target.checked;
            },
            ValueResultComboIdNoe10(value) {
                if (value.id != null) {
                    this.DataAxios.TblComboIdNoe10 = value.id;
                }
            },
            Refresh() {
                this.AddZamenVaMoaref = 0
                this.DataAxios={}
            },
            GetGridColumns() {
                this.$GetColumns(this.DataAxoisColumns, true)
                    .then((data) => {
                        this.columns = data
                    })
                    .finally(() => {
                        this.$store.state.renderComponentGrid = false
                        this.$nextTick(() => {
                            this.$store.state.renderComponentGrid = true
                        })
                    })
            },
            Search() {
                this.DataAxiosSearch.Action = "zamenVaMoaref/Index?id=" + this.TblTaahodatId;
                this.DataAxiosSearch.Method = "post";
                this.$PostData(this.DataAxiosSearch)
                    .then((data) => {
                        if (data.length > 0) {

                            let info;
                            let list = [];
                            for (let index = 0; index < data.length; index++) {
                                info = data[index];
                                info["row"] = index + 1;
                                list.push(info);

                            }
                            this.rows = list
                            this.$FormatMablaghGrid(this.rows)
                        }
                    }).finally(() => {
                        this.$store.state.renderComponentGrid = false;
                        this.$nextTick(() => {
                            this.$store.state.renderComponentGrid = true;
                        });

                    })
            },
            GetAzaSearched(value) {
                this.DetailZamen = value;
                this.DataAxios.OzvName =
                    this.DetailZamen.OzvName;
                this.DataAxios.OzvFamily =
                    this.DetailZamen.OzvFamily;
                this.DataAxios.ShomareOzv =
                    this.DetailZamen.ShomareOzv;
                this.DataAxios.TblAzaId = this.DetailZamen.Id;
                this.DataAxios.Mobile =
                    this.DetailZamen.Mobile;
            },
            SearchShomareozv(e) {
                if (e.key == "Enter") {
                    e.target.value = e.target.value.replace(
                        this.$session.get("UserInfo").codeShobe.trim() + "-", "");
                    e.target.value = e.target.value.padStart(6, 0);
                    e.target.value =
                        this.$session.get("UserInfo").codeShobe.trim() + "-" + e.target.value;
                    this.DataAxios.ShomareOzv = e.target.value;
                    var DataAxiosSerch = {
                        ArryfildValue: {
                            ShomareOzv: e.target.value,
                            OzvFamilyName: "",
                            Mobile: "",
                            CodeMeli: "",
                            Shenasname: "",
                            OzvFamily: "",
                            OzvName: "",
                            Parvandeh: "",
                        },
                    };
                    DataAxiosSerch.ArryfildValue.TblGrpId = this.$session.get("UserInfo").tblGrpId;
                    DataAxiosSerch.ArryfildValue.tblShobeId = this.$session.get("UserInfo").tblShobeId;
                    DataAxiosSerch.Action = "vorodi";
                    DataAxiosSerch.Method = "post";
                    this.$PostData(DataAxiosSerch).then((data) => {
                        if (data.length > 0) {
                            if (data[0].ShomareOzv.trim() == this.AzaInfo.ShomareOzv.trim()) {
                                this.$mySweetDefaultTost("هشدار ",
                                    "شماره عضو وارد شده با شماره عضو فردی که برای آن ضامن تعریف می کنید برابر می باشد",
                                    "warning", 4000);
                            } else {

                                this.DetailZamen = data[0];
                                this.DataAxios.OzvName = this.DetailZamen.OzvName;
                                this.DataAxios.OzvFamily = this.DetailZamen.OzvFamily;
                                this.DataAxios.TblAzaId = this.DetailZamen.Id;
                                this.DataAxios.Mobile = this.DetailZamen.Mobile;

                            }
                        } else {
                            this.DataAxios.OzvName = "";
                            this.DataAxios.OzvFamily = "";
                            this.ListHesabOzv = [];
                            this.$mySweetDefaultTost(
                                "عدم وجود اطلاعات",
                                "عضوی با شماره عضو وارد شده یافت نشد ",
                                "info",
                                3000
                            );
                        }
                    });
                }
            },
            GetAzaTaahodat() {
                if (
                    document.getElementById("txtOzvName").value != "" &&
                    (this.DetailZamen.Id != 0 ||
                        this.DetailZamen.Id != null)
                ) {
                    var DataAxiosRow = {
                        ArryfildValue: "",
                        Method: "POST",
                        Action: "AzaPasAndJari/Index",
                        Token: this.$session.get("Token"),
                    };
                    DataAxiosRow.ArryfildValue = {
                        tblAzaId: this.DetailZamen.Id,
                        tblShobeId: this.$session.get("UserInfo").tblShobeId,
                        tblGrpId: this.$session.get("UserInfo").tblGrpId,
                    };
                    console.log('DataAxiosRow.ArryfildValue', DataAxiosRow.ArryfildValue);
                    this.$PostData(DataAxiosRow).then((data) => {
                        let ListHesabOzv = [];

                        if (this.AddZamenVaMoaref != 0) {
                            console.log('AddZamenVaMoaref!=0');
                            data.forEach((element) => {
                                if (element.GhabelBardasht > 0) {
                                    let obj = {
                                        Id: 0,
                                        VCode: ""
                                    };
                                    obj.VCode = element.Vcode;
                                    obj.Id = element.Id;
                                    ListHesabOzv.push(obj);
                                }
                            });
                            this.ListHesabOzv = ListHesabOzv;
                        } else {
                            data.forEach((element) => {
                                if (element.GhabelBardasht > 0) {
                                    let obj = {
                                        Id: 0,
                                        VCode: ""
                                    };
                                    obj.VCode = element.Vcode;
                                    obj.Id = element.Id;
                                    ListHesabOzv.push(obj);
                                }
                            });
                            this.ListHesabOzv = ListHesabOzv;
                        }
                    })
                }
            },
            DetailAza() {
                try {
                    if (document.getElementById("txtOzvName").value == "") {
                        this.$mySweetDefaultTost(
                            "عدم انتخاب مشتری",
                            "مشتری را لطفا انتخاب کنید و دوباره تلاش کنید",
                            "warning",
                            3000
                        );
                    } else {
                        this.$store.state.AzaPasAndJari.CopyRowData[0] =
                            this.DetailZamen;
                        this.$store.state.AzaTashilats.CopyRowData[0] =
                            this.DetailZamen;
                        this.DataAxios_tblaza.Action =
                            "AzaInfo/?id=" + this.DetailZamen.Id;
                        // this.DataAxios_tblaza.ArryfildValue = null;
                        this.$store.state.AzaInfo.EditData[0] =
                            this.DetailZamen;
                        this.$GetData_Body(this.DataAxios_tblaza)
                            .then((data) => {
                                // console.log("***********", data);
                                this.$store.state.AzaInfo.EditData[0] = data;
                                this.$store.state.OldDataForLog = JSON.stringify(data);
                                this.$router.push({
                                    name: "AzaInfo",
                                    params: {
                                        Status: "Edit"
                                    },
                                });
                            })
                            .finally(() => {});
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            AzaPasAndJari() {
                try {
                    if (
                        this.DetailZamen != null &&
                        document.getElementById("txtOzvName").value != ""
                    ) {
                        this.$store.state.AzaPasAndJari.RowData[0] =
                            this.DetailZamen;
                        this.$router.push({
                            name: "AzaPasAndJari"
                        });
                    } else {
                        this.$mySweetDefaultTost(
                            "عدم انتخاب مشتری",
                            "مشتری را لطفا انتخاب کنید و دوباره تلاش کنید",
                            "warning",
                            3000
                        );
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            ValueResultTblAzaHesab(value) {
                this.DataAxios.TblAzaIdHesabZamen = value;
                console.log("HHHHH", value);
            },
            ValueResultTblComboRaveshAzadSazi23ZamenVaMoaref(value) {
                console.log("روش آزاد سازی", value);
            },
            FocusOut(e) {
                if (e.target.value != "0" && e.target.value == "") {
                    e.target.value = "0";
                }
            },
            Focus(e) {
                if (e.target.value == "0" && e.target.value != "") {
                    e.target.value = "";
                }
            },
        },
        mounted() {
            this.GetGridColumns()
            this.Search();
            this.DataAxios.TblTaahodatId = this.TblTaahodatId
        }
    }
</script>
<style scoped>

</style>